import React from 'react'
import { Container, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'

const QuestionnaireTitle = () => {
  const questionnaireMetadata = useSelector(
    (state) => state.questionnaireMetadata
  )

  const title = questionnaireMetadata?.title || 'Untitled Questionnaire'

  return (
    <Container style={{ textAlign: 'center' }} maxWidth='md'>
      <Typography
        variant='h4'
        style={{ marginTop: '2em', marginBottom: '1em' }}
      >
        {title}
      </Typography>
    </Container>
  )
}

export default QuestionnaireTitle
